import React from 'react';
export const BlockHeader = ({ title, cta, loading = false }) => {
    return (React.createElement("div", { className: "block-header" },
        loading ? React.createElement("div", { className: "block-header_title--loading" }) : React.createElement("h5", null, title),
        cta && loading ? (React.createElement("div", { className: "block-header_cta--loading" })) : (React.createElement("div", { className: "block-header_cta" }, cta))));
};
//# sourceMappingURL=BlockHeader.js.map